<template>
  <div class="online-appointment-view">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "OnlineAppointmentView",
}
</script>
